const UserRoles = {
	publisher: 0,
	author: 1,
	researcher: 2,
};
export default UserRoles;
